<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-solid">
        <div class="box-body">
          <div class="form-group">
            <label for="uraian">Uraian Revisi</label>
            <textarea v-model="uraianField" rows="10" class="form-control" id="uraian" placeholder="Bab, halaman,  uraian, keterangan, dan lain-lain."></textarea>
          </div>
          <p></p>
          <div class="form-group">
            <label for="foto">Foto/File</label>
            <input ref="foto" type="file" id="foto">
          </div>
          <p>
            <template v-if="fileUrl">
              <a :href="fileUrl"><span class="fa fa-paperclip"></span> Tautan File Tersimpan</a>
            </template>
          </p>
          <p>
            <strong>Dosen</strong><br>
            {{ assessor }}
          </p>
          <p></p>
          <p><strong>Pengoreksi Revisi</strong></p>
          <div class="radio">
            <label>
              <input type="radio" id="saya" value="0" v-model="dikoreksiPembimbing">
              Saya sendiri
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" id="pembimbing" value="1" v-model="dikoreksiPembimbing">
              Diserahkan ke pembimbing
            </label>
          </div>
          <p></p>
          <button
            @click.stop="save()"
            type="button"
            class="btn btn-primary">Simpan</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  props: ['tesis_id', 'assessor', 'uraian', 'dikoreksi_pembimbing', 'foto'],
  data: () => ({
    uraianField: '',
    fotoDisplay: '',
    dikoreksiPembimbing: 0,
    fileUrl: null,
  }),
  methods: {
    async save() {
      let formData = new FormData()
      formData.append('foto', this.$refs.foto.files[0])
      formData.append('uraian', this.uraianField)
      formData.append('dikoreksi_pembimbing', this.dikoreksiPembimbing)

      let response = await axios.post(
        '/tesis/daftar-revisi/' + this.tesis_id,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' }, }
      )

      this.fotoDisplay = response.data.foto
      this.fileUrl = '/'+response.data.foto

      window.$.notify({
        // options
        message: 'Uraian revisi berhasil disimpan.'
      },{
        // settings
        type: 'success',
        delay: 1250,
        placement: {
          from: "top",
          align: "center"
        },
      });
    },
  },
  mounted() {
    this.uraianField = this.uraian
    this.dikoreksiPembimbing = this.dikoreksi_pembimbing
    this.fotoDisplay = this.foto
    if (this.foto) {
      this.fileUrl = '/'+this.foto
    }
  },
}
</script>